import styled from "styled-components";
import { ButtonSettings } from "../../../services/visualLibraryService";

export const PageWrapper = styled.div`
  ${props => (props.direction === "rtl" ? "padding-right:" : "padding-left:")} 6.52rem;
  padding-top: 4.17rem;
`;

export const LogoStyled = styled.div`
  position: absolute;
  ${props => (props.direction === "rtl" ? "left:" : "right:")} 4.55rem;
`;

export const PageContentStyled = styled.div`
  width: 72.71rem;
`;

export const TitleWithDescriptionStyled = styled.div``;

export const TitleStyled = styled.p`
  color: ${props => props.theme.color.white};
  font-size: 2.5rem;
  font-weight: ${props => props.theme.font.weight.semiBold};
  line-height: 3.07rem;
`;
export const DescriptionStyled = styled.p`
  color: ${props => props.theme.color.greyLight};
  font-size: 1.25rem;
  margin-top: 0.83rem;
  line-height: 1.5rem;
`;

export const SeparatorStyled = styled.div`
  height: 0.104rem;
  width: 100%;
  opacity: 0.24;
  background-color: ${props => props.theme.color.greyLight};
  margin-top: 2.08rem;
`;

export const CardsContainerStyled = styled.ul`
  display: flex;
  align-items: center;
  margin-top: 5.21rem;

  & + ${SeparatorStyled} {
    margin-top: 3.33rem;
  }
`;

export const RadioIconStyled = styled.div`
  height: 2.08rem;
  width: 2.08rem;
  border-radius: 50%;
  border: 0.21rem solid ${props => props.theme.color.white};

  background: inherit;
  position: relative;
  ${props =>
    props.isActive
      ? `
        &:after {
          content: " ";
          display: block;
          position: absolute;
          top: 0.42rem;
          right: 0.42rem;
          bottom: 0.42rem;
          left: 0.42rem;
          border-radius: 50%;
          background: white;
        }
      `
      : ""}

  ${props =>
    props.isFocused && props.isFocused === props.isActive
      ? `
            &:after {
              content: " ";
              display: block;
              position: absolute;
              top:0.42rem;
              right: 0.42rem;
              bottom: 0.42rem;
              left: 0.42rem;
              border-radius: 50%;
                background: ${props => props.theme.color.white} !important;
              border: 0.21rem solid ${props => props.theme.color.white}!important;
              ;
            }
          `
      : ""}
`;

export const CategoryCardStyled = styled.li`
  cursor: pointer;
  box-sizing: content-box;
  border: 3px solid transparent;
  border-radius: 0.42rem;
  padding: 1.29rem;
  width: 14.11rem;
  ${props => props.direction === "ltr" && "margin-right:1.5rem"};
}

  padding: 1.29rem;
  //height: 8.27rem;
  width: 14.11rem;
   ${props => (props.direction === "ltr" ? "margin-right:1.5rem;" : "margin-left:1.5rem;")};
  ${props => (props.isActive ? `border: 3px solid ${props.theme.color.greyLight};` : "")}
  ${props => (props.isFocused ? `border: 3px solid ${props.theme.color.primary}; ` : "")}
`;

export const CategoryCardDivStyled = styled.div`
  border: 1px solid rgba(209, 211, 212, 0.2);
  width: 17rem;
  height: 9.7rem;
  position: absolute;
  background-color: ${props => props.theme.color.greyBlack};
  border-radius: 0.42rem;
  box-shadow: rgb(0 0 0 / 50%) 0px 0px 30px 0px;
  z-index: -1;
`;

export const CategoryCardHeaderStyled = styled.div`
  display: flex;
  align-items: center;
`;

export const RadioLabelStyled = styled.p`
  color: ${props => props.theme.color.white};
  font-size: 1.67rem;
  font-weight: ${props => props.theme.font.weight.semiBold};
  ${props => (props.direction === "rtl" ? "margin-right: 0.83rem" : "margin-left: 0.83rem")};
`;

export const CategoryCardDescriptionStyled = styled.div`
  color: ${props => props.theme.color.greyLight};
  font-size: 1.25rem;
  line-height: 1.52rem;
  text-align: ${props => (props.direction === "rtl" ? "right" : "left")};
  margin-top: 1.25rem;
`;

export const CheckboxContainerStyled = styled.div`
  display: flex;
  align-items: center;

  color: ${props => props.theme.color.white};
  margin-top: 2.08rem;
`;

export const CheckboxStyled = styled.input`
  &[type="checkbox"] {
    height: ${props => props.height};
    width: ${props => props.width};
    visibility: hidden;
    ${props => (props.direction === "ltr" ? "margin-right:1.67rem;" : "margin-left:1.67rem;")};
    cursor: pointer;
    position: relative;

    height: ${props => props.height};
    width: ${props => props.width};

    &:before {
      content: "";
      position: absolute;

      top: 0;
      left: 0;
      bottom: 0;
      right: 0;

      border: 4px solid ${props => props.theme.color.offWhite};
      border-radius: 4px;
      background-color: transparent;
      visibility: visible;
    }

    &.focused:not(:checked):before {
      border: 4px solid ${props => props.theme.color[props.focussedBorderColor]} !important;
    }

    &:checked:before {
      border: unset;
      background-image: url(/images/icons/Check-gray.png) !important;
      visibility: visible;
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
    }
    &.focused:checked:before {
      border: unset;
      background-image: url(/images/icons/checkbox-checked-white.png) !important;
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;s
    }
  }
`;

export const CheckboxContentStyled = styled.div``;

export const CheckboxTitleStyled = styled.p`
  font-size: 1.67rem;
  font-weight: ${props => props.theme.font.weight.semiBold};
  letter-spacing: 0;
  line-height: 2.025rem;
`;

export const CheckboxDescriptionStyled = styled.p`
  font-size: 1.25rem;
  letter-spacing: 0;
  line-height: 1.52rem;
  margin-top: 0.62rem;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  margin-top: 3.33rem;
`;

export const ButtonStyled = styled(ButtonSettings)`
  cursor: pointer;
  width: 23.95rem;
  height: 3.4375rem;
  border-radius: 8px;
  background-color: ${props => props.theme.color.secondary};
  ${props => (props.operation === "save" && props.direction === "ltr" ? "margin-left: 0rem;" : "margin-left:1.25rem;")};
  ${props =>
    props.operation === "cancel" && props.direction === "ltr" ? "margin-right:1.25rem;" : "margin-right:0rem;"};
  font-size: 1.67rem;
  padding: 0.57rem 0;
  box-sizing: border-box;
  ${props => props.disabled && `opacity: 0.6`};

  span {
    line-height: 1.875rem !important;
  }
`;
